export default __webpack_public_path__ + "static/char-s-53-ja-3d6fc1f68d2bec920bc811a033e73e1a.png";